module.exports = __webpack_public_path__ + "img/needs- improvement.f6e5eff2.png";